import { paths } from "helpers/paths";
import { deletedFilters } from "helpers/redux";
import { paramsObject } from "helpers/system";
import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/cargoOwners";
import List from "./list";
import Show from "./show";

export default function CargoOwners(props) {
    const { match, location, history, clearParams } = props;

    useEffect(() => {
        return () => {
            clearParams("cargoowners", deletedFilters());
        };
    }, []);

    const back = () => history.push(match.path);

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    path={`${match.path}/:id`}
                    render={(rest) => {
                        const { history } = rest;
                        const { fromGroup } = paramsObject(rest.location.search);
                        const backAction = fromGroup
                            ? () => history.push(paths.counterpartyGroupsShow(fromGroup))
                            : back;

                        return (
                            <Show {...rest} transition="full" title="Контрагент" back={backAction} source={source} />
                        );
                    }}
                />
                <Route
                    exact
                    path={match.path}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            createBtnText="Создать контрагента"
                            title="Список контрагентов"
                            nofilter
                            source={source}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}
